import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "filename", "remove", "dropzone"]

  connect() {
    this.reset()
  }

  reset() {
    if (this.previewTarget) {
      this.previewTarget.innerHTML = ''
      this.previewTarget.classList.add('hidden')
    }
    if (this.filenameTarget) {
      this.filenameTarget.textContent = ''
    }
    if (this.removeTarget) {
      this.removeTarget.classList.add('hidden')
    }
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('ring-2', 'ring-dashed', 'ring-brand_blue-100')
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('ring-2', 'ring-dashed', 'ring-brand_blue-100')
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('ring-2', 'ring-dashed', 'ring-brand_blue-100')
    const files = event.dataTransfer.files
    if (!files || files.length === 0) return
    this.inputTarget.files = files
    this.previewFile(files[0])
  }

  change(event) {
    const files = event.target.files
    if (!files || files.length === 0) {
      this.reset()
      return
    }
    this.previewFile(files[0])
  }

  previewFile(file) {
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      const src = e.target.result
      if (this.previewTarget) {
        this.previewTarget.innerHTML = `<img src="${src}" alt="preview" class="w-32 h-32 object-cover rounded-md"/>`
        this.previewTarget.classList.remove('hidden')
      }
      if (this.filenameTarget) {
        this.filenameTarget.textContent = file.name
      }
      if (this.removeTarget) {
        this.removeTarget.classList.remove('hidden')
      }
    }
    reader.readAsDataURL(file)
  }

  removeFile(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.reset()
  }
}
